import React from 'react';
import { Widget } from 'shared/containers/portal_layout';

const PrimaryInsurance = ({ primaryInsurance, primaryInsuranceDetails }) => (
  <Widget title="Primary Insurance" className="nopadding" span={12}>
    {primaryInsurance ? (
      <table className="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Name: </td>
            <td>{primaryInsurance.name}</td>
          </tr>
          <tr>
            <td>ID: </td>
            <td>{primaryInsurance.id}</td>
          </tr>
          <tr>
            <td>Plan Name</td>
            <td>{primaryInsuranceDetails.planName}</td>
          </tr>
          <tr>
            <td>Plan Type</td>
            <td>{primaryInsuranceDetails.planType}</td>
          </tr>
          <tr>
            <td>Plan Type Label</td>
            <td>{primaryInsuranceDetails.planTypeLabel}</td>
          </tr>
          <tr>
            <td>Group Name: </td>
            <td>{primaryInsuranceDetails.groupName}</td>
          </tr>
          <tr>
            <td>Plan Begins: </td>
            <td>
              {primaryInsuranceDetails.dates && (
                <Date date={primaryInsuranceDetails.dates.find(d => d.dateType === 'plan_begin')} />
              )}
            </td>
          </tr>
          <tr>
            <td>Plan Ends: </td>
            <td>
              {primaryInsuranceDetails.dates && (
                <Date date={primaryInsuranceDetails.dates.find(d => d.dateType === 'plan_end')} />
              )}
            </td>
          </tr>
        </tbody>
      </table>
    ) : (
      <p>No primary insurance data</p>
    )}
  </Widget>
);

const Date = ({ date }) => {
  if (!date) return null;
  return <span>{date.dateValue}</span>;
};

export default PrimaryInsurance;
